const defaultState = {
  suppliers: null,
  storeList: null,
  storeListAll: null,
  storeCode: localStorage.getItem('storeCode') || null,
}

function commonReducer(state = defaultState, action) {
  console.log(action.type);
  switch (action.type) {
    case 'common/suppliers':
      let suppliers = action.payload
      return {
        ...state,
        suppliers
      }
    case 'store/list':
      let storeList = action.payload
      return {
        ...state,
        storeList
      }
    case 'store/list/all':
      let storeListAll = action.payload
      return {
        ...state,
        storeListAll
      }
    case 'common/storeCode':
      let storeCode = action.payload || null
      storeCode && localStorage.setItem('storeCode', storeCode)
      return {
        ...state,
        storeCode,
      }
    case 'common/storeCodeAll':
      let storeCodeAll = action.payload || null
      storeCodeAll && localStorage.setItem('storeCodeAll', storeCodeAll)
      return {
        ...state,
        storeCodeAll,
      }
    case 'common/suppliers/update':
      let newSuppliers = state.suppliers
      const newSupplier = action.payload
      let oldSupplier
      let newSupplierIndex = -1
      if (newSuppliers) {
        newSuppliers.forEach((supplier, index) => {
          if (supplier.id === newSupplier.id) {
            newSupplierIndex = index
            oldSupplier = supplier
          }
        })
        if (newSupplierIndex >= 0) {
          newSuppliers[newSupplierIndex] = {
            ...oldSupplier,
            ...newSupplier
          }
        }
      }
      return {
        ...state,
        suppliers: newSuppliers
      }
    default:
      return state
  }
}
export default commonReducer
